<style src="./PaymentsList.scss" lang="scss"></style>
<template>
  <div class="PaymentsList">
    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead class="table-head">
          <tr>
            <th>Status</th>
            <th>Criado Em</th>
            <th>Código</th>
            <th>Placa</th>
            <th>Nome</th>
            <th>CPF</th>
            <th>E-mail</th>
            <th>Telefone</th>
            <th>Valor R$</th>
            <th></th>
          </tr>
        </thead>

        <tbody class="table-list">
          <tr v-for="(item, itemIndex) in list" :key="itemIndex">
            <td>
              <i v-if="item.isAuthorized" class="fa fa-check"></i>
            </td>
            <td>{{ formatDateBR(item.createdAt) }}</td>
            <td>{{ item.creditCode }}</td>
            <td>{{ formatLicencePlate(item.vehicle.licencePlate) }}</td>
            <td>{{ item.user && item.user.fullName }}</td>
            <td>{{ item.user && item.user.cpf }}</td>
            <td>{{ item.user && item.user.email }}</td>
            <td>{{ item.user && item.user.cellPhone }}</td>
            <td>{{ formatCurrency(item.amountPaid) }}</td>
            <td>
              <span
                v-if="item.isAuthorized"
                class="btn-circle btn-white"
                :title="item.reason"
              >
                <i class="fa fa-info"> </i>
              </span>
              <button
                type="button"
                v-if="!item.isAuthorized"
                class="btn btn-success"
                @click="() => confirmAuthorization(item)"
              >
                Reativar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ModalConfirmAuthorization
      :show="showConfirmAuthorization"
      @close-modal="closeModalConfirmAuthorization"
      @confirm="doConfirmAuthorization"
      :payment-info="paymentInfo"
    />
  </div>
</template>
<script>
import ModalConfirmAuthorization from '../modal-confirm-authorization/ModalConfirmAuthorization.vue';

export default {
  components: {
    ModalConfirmAuthorization,
  },
  props: {
    list: {
      default: () => [],
    },
  },
  data: () => ({
    showConfirmAuthorization: false,
    paymentInfo: {},
  }),
  methods: {
    formatDateBR(value) {
      const options = {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      };
      const dt = new Intl.DateTimeFormat('pt-BR').format(new Date(value));
      const tm = new Intl.DateTimeFormat('pt-BR', options).format(
        new Date(value),
      );
      return `${dt} ${tm}`;
    },
    formatLicencePlate(value) {
      const upper = value.toUpperCase();
      const dash = upper.substring(0, 3) + '-' + upper.substring(3, 7);
      return dash;
    },
    formatCurrency(value) {
      if (!value) {
        return '0,00';
      }
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    confirmAuthorization(info) {
      this.paymentInfo = info;
      this.showConfirmAuthorization = true;
    },
    closeModalConfirmAuthorization({ refresh = false }) {
      if (refresh) {
        this.$emit('refresh');
      }
      this.showConfirmAuthorization = false;
    },
    doConfirmAuthorization() {},
  },
};
</script>
